import { openDB } from './trendingCache';

const RECOMMEND_CACHE_KEY = 'recommend_cache';
const RECOMMEND_CACHE_TTL = 6 * 60 * 60 * 1000; // 6 hours in ms
const RECOMMEND_STORE_NAME = 'recommend_cache';


/**
 * Lưu danh sách sách đề xuất vào IndexedDB.
 * @param {Array} data - mảng sách đề xuất
 * @param {string} userId - ID hoặc username để phân biệt user
 */
export async function saveRecommendToCache(data, userId = 'default') {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(RECOMMEND_STORE_NAME, 'readwrite');
      const store = tx.objectStore(RECOMMEND_STORE_NAME);
      const cacheKey = `${RECOMMEND_CACHE_KEY}_${userId}`;
      const request = store.put({ data, timestamp: Date.now(), userId }, cacheKey);
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  } catch (e) {
    console.error('Lỗi khi lưu cache Đề xuất vào IndexedDB:', e);
  }
}

/**
 * Đọc danh sách sách đề xuất từ IndexedDB.
 * Cache tồn tại tối đa 6 tiếng (RECOMMEND_CACHE_TTL).
 * @param {string} userId - ID hoặc username để phân biệt user
 * @returns {Array|null} - mảng sách hoặc null nếu không có cache / cache hết hạn
 */
export async function loadRecommendFromCache(userId = 'default') {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(RECOMMEND_STORE_NAME, 'readonly');
      const store = tx.objectStore(RECOMMEND_STORE_NAME);
      const cacheKey = `${RECOMMEND_CACHE_KEY}_${userId}`;
      const request = store.get(cacheKey);
      request.onsuccess = () => {
        const cached = request.result;
        if (!cached || !cached.data || !Array.isArray(cached.data) || cached.data.length === 0 || !cached.timestamp) {
          resolve(null);
          return;
        }
        if (Date.now() - cached.timestamp >= RECOMMEND_CACHE_TTL) {
          clearRecommendCache(userId);
          resolve(null);
          return;
        }
        resolve(cached.data);
      };
      request.onerror = () => reject(request.error);
    });
  } catch (e) {
    console.error('Lỗi khi đọc cache Đề xuất từ IndexedDB:', e);
    return null;
  }
}

/**
 * Xóa cache đề xuất trong IndexedDB.
 * @param {string|null} userId - ID hoặc username của user (nếu null/không truyền -> xóa toàn bộ store)
 */
export async function clearRecommendCache(userId = null) {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(RECOMMEND_STORE_NAME, 'readwrite');
      const store = tx.objectStore(RECOMMEND_STORE_NAME);
      const request = userId
        ? store.delete(`${RECOMMEND_CACHE_KEY}_${userId}`)
        : store.clear();
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  } catch (e) {
    console.error('Lỗi khi xóa cache Đề xuất trong IndexedDB:', e);
  }
}

/** Alias tương thích cho module cũ/hot-reload */
export const clearAllRecommendCache = clearRecommendCache;
